// ===================================================
// ФАЙЛ: frontend/src/pages/Error/TooManyRequestsPage.jsx
// ===================================================
import React from 'react';
import MonumentErrorLayout from '../../components/Error/MonumentErrorLayout';
import { SUPPORT_EMAIL } from '../../utils/externalLinks';

const TooManyRequestsPage = () => {
  return (
    <MonumentErrorLayout
      status="429"
      title="Слишком много запросов"
      description="Колодец переполнен запросами. Подождите минутку и попробуйте снова."
      bgImageName="429"
    >
      <div className="mb-err-page__actions-row">
        <button type="button" className="mb-err-page__cta" onClick={() => window.location.reload()}>
          Попробовать снова
        </button>
        <a className="mb-err-page__cta mb-err-page__cta--secondary" href={`mailto:${SUPPORT_EMAIL}`}>
          Написать в поддержку
        </a>
      </div>
    </MonumentErrorLayout>
  );
};

export default TooManyRequestsPage;
